// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b1e27adf","455":"b0679b27"}[chunkId] + ".chunk.js";
};